/**
 * Attributes used in system shapes and node data.
 */
export const Attribute = {
    /**
     * If set to true, the element has a custom position and is not part of the automatic diagram layout.
     */
    CustomPosition: 'customPosition',
    /**
     * If set to true, the element can only be a source of links, not a target.
     */
    SourceOnly: 'sourceOnly',
    /**
     * The index of the link among all outgoing links from the source node.
     */
    SourceIndex: 'sourceIndex'
};
